<template>
  <div class="tixian-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goToProfile">个人中心</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item" @click="goToWallet">钱包</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item active">提现</span>
    </div>

    <div class="con-box">
      <!-- 余额信息 -->
      <div class="balance-info">
        <div class="balance-label">我的余额</div>
        <div class="balance-amount">{{ balanceAmount }}</div>
      </div>

      <!-- 提现金额 -->
      <div class="withdraw-section">
        <div class="withdraw-label">提现金额</div>
        <div class="amount-input-container">
          <el-input
            v-model="withdrawAmount"
            placeholder="请输入提现金额"
            type="number"
            class="amount-input"
            @input="updateWithdrawAmount"
          />
        </div>
        <div class="amount-tips">
          <span class="tip-text">可提现余额：¥{{ balanceAmount }}</span>
          <span class="all-btn" @click="withdrawAll">全部提现</span>
        </div>
      </div>

      <!-- 提现方式 -->
      <div class="withdraw-methods">
        <div class="methods-label">提现方式</div>
        <div class="methods-list">
          <div
            v-for="method in withdrawMethods"
            :key="method.id"
            class="method-item"
            :class="{ active: selectedMethod === method.id }"
            @click="selectMethod(method.id)"
          >
            <img class="method-icon" :src="method.icon" :alt="method.name">
            <span class="method-name">{{ method.name }}</span>
            <div class="method-check">
              <img
                v-if="selectedMethod === method.id"
                class="check-icon-img"
                :src="require('@/assets/image/sely.png')"
                alt="选中"
              >
              <img
                v-else
                class="check-icon-img"
                :src="require('@/assets/image/seln.png')"
                alt="未选中"
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 银行卡：银行名称 + 卡号 + 开户行 -->
      <div v-if="selectedMethod === 'bank'" class="withdraw-account bank-fields">
        <div class="account-label">收款银行卡信息</div>
        <div class="field-row">
          <span class="field-hint">银行名称</span>
          <el-input v-model="bankName" placeholder="请输入银行名称" class="account-input" />
        </div>
        <div class="field-row">
          <span class="field-hint">银行卡号</span>
          <el-input v-model="bankAccount" placeholder="请输入银行卡号" class="account-input" />
        </div>
        <div class="field-row">
          <span class="field-hint">开户行</span>
          <el-input v-model="bankBranch" placeholder="请输入开户行" class="account-input" />
        </div>
      </div>

      <!-- 微信 / 支付宝：上传收款码 -->
      <div v-else-if="selectedMethod === 'wechat' || selectedMethod === 'alipay'" class="withdraw-account qr-section">
        <div class="account-label">{{ selectedMethod === 'wechat' ? '微信' : '支付宝' }}收款码</div>
        <div class="qr-upload-wrap">
          <input
            ref="qrFileInput"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            class="qr-file-input"
            @change="onQrFileChange"
          >
          <div
            class="qr-upload-box"
            :class="{ uploading: qrUploading }"
            @click="triggerQrUpload"
          >
            <img v-if="qrPreview" :src="qrPreview" alt="收款码预览" class="qr-preview-img">
            <template v-else>
              <i class="el-icon-plus qr-upload-icon" />
              <div class="qr-upload-text">点击上传收款码</div>
              <div class="qr-upload-sub">支持 JPG、PNG，不超过 5MB</div>
            </template>
            <div v-if="qrUploading" class="qr-upload-loading"><i class="el-icon-loading" /></div>
          </div>
        </div>
      </div>

      <!-- 提现信息 -->
      <div class="withdraw-info">
        <div class="info-item">
          <span class="info-label">提现金额</span>
          <span class="info-value">¥{{ withdrawAmount || 0 }}</span>
        </div>
        <div class="info-item total">
          <span class="info-label">实际到账</span>
          <span class="info-value">¥{{ actualAmount }}</span>
        </div>
      </div>

      <!-- 提现按钮 -->
      <div class="withdraw-actions">
        <el-button
          type="primary"
          class="withdraw-btn"
          :disabled="withdrawSubmitDisabled"
          @click="handleWithdraw"
        >
          确认提现
        </el-button>
      </div>

      <!-- 提现说明 -->
      <div class="withdraw-tips">
        <div class="tips-title">提现说明</div>
        <div class="tips-list">
          <div class="tip-item">• 提现申请提交后，1-3个工作日内到账</div>
          <div class="tip-item">• 单笔提现金额最低10元，最高50000元</div>
          <div class="tip-item">• 如遇节假日，到账时间可能顺延</div>
        </div>
      </div>
    </div>

    <!-- 支付密码弹窗 -->
    <el-dialog
      :title="passwordDialogType === 'set' ? '设置支付密码' : '验证支付密码'"
      :visible.sync="showPasswordDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="password-dialog">
        <div class="password-tip">
          {{ passwordDialogType === 'set' ? '为了您的资金安全，请设置支付密码' : '请输入支付密码进行验证' }}
        </div>
        <el-input
          v-model="paymentPassword"
          type="password"
          :placeholder="passwordDialogType === 'set' ? '请输入6位支付密码' : '请输入支付密码'"
          maxlength="6"
          show-password
          class="password-input"
        />
        <div class="password-tips">
          <div class="tip-item">• 支付密码用于提现验证</div>
          <div class="tip-item">• {{ passwordDialogType === 'set' ? '请设置6位数字密码' : '请输入6位数字密码' }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPasswordDialog">取消</el-button>
        <el-button type="primary" @click="handlePasswordConfirm">
          {{ passwordDialogType === 'set' ? '确认设置' : '确认提现' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProfile, withdraw, setPaymentPassword, uploadImage } from '@/api/user'

export default {
  name: 'Tixian',
  data() {
    return {
      userInfo: {},
      balanceAmount: '0.00',
      withdrawAmount: '',
      selectedMethod: '',
      bankName: '',
      bankAccount: '',
      bankBranch: '',
      paymentQrCode: '',
      qrPreview: '',
      qrUploading: false,
      paymentPassword: '', // 支付密码
      showPasswordDialog: false, // 显示设置支付密码弹窗
      passwordDialogType: 'set', // 弹窗类型：set=设置密码, verify=验证密码
      withdrawMethods: [
        {
          id: 'bank',
          name: '银行卡',
          icon: require('@/assets/image/my/yhk.png'),
          type: 1
        },
        {
          id: 'wechat',
          name: '微信',
          icon: require('@/assets/image/my/wx.png'),
          type: 2
        },
        {
          id: 'alipay',
          name: '支付宝',
          icon: require('@/assets/image/my/zfb.png'),
          type: 3
        }
      ]
    }
  },
  computed: {
    actualAmount() {
      if (!this.withdrawAmount || this.withdrawAmount <= 0) return 0
      return this.withdrawAmount
    },
    withdrawSubmitDisabled() {
      if (!this.withdrawAmount || Number(this.withdrawAmount) <= 0 || !this.selectedMethod) return true
      if (this.selectedMethod === 'bank') {
        return !this.bankName.trim() || !this.bankAccount.trim() || !this.bankBranch.trim()
      }
      if (this.selectedMethod === 'wechat' || this.selectedMethod === 'alipay') {
        return !this.paymentQrCode
      }
      return true
    }
  },
  async mounted() {
    await this.fetchProfile()
  },
  beforeDestroy() {
    if (this.qrPreview && this.qrPreview.startsWith('blob:')) {
      try { URL.revokeObjectURL(this.qrPreview) } catch (e) { /* ignore */ }
    }
  },
  methods: {
    // 获取个人资料
    async fetchProfile() {
      try {
        const response = await getProfile()
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.userInfo = {
            id: data.id,
            nickname: data.nickname,
            avatar: data.avatar,
            money: data.money,
            payment_password: data.payment_password,
            phone: data.phone,
            real_name_status: data.real_name_status,
            real_name_verified: data.real_name_verified
          }
          this.balanceAmount = data.money || '0.00'
        }
      } catch (error) {
        console.error('获取个人资料失败:', error)
        this.$message.error('获取用户信息失败')
      }
    },
    goToProfile() {
      this.$router.push('/profile')
    },
    goToWallet() {
      this.$router.go(-1)
    },
    selectMethod(methodId) {
      this.selectedMethod = methodId
      this.bankName = ''
      this.bankAccount = ''
      this.bankBranch = ''
      this.paymentQrCode = ''
      if (this.qrPreview && this.qrPreview.startsWith('blob:')) {
        try { URL.revokeObjectURL(this.qrPreview) } catch (e) { /* ignore */ }
      }
      this.qrPreview = ''
      if (this.$refs.qrFileInput) this.$refs.qrFileInput.value = ''
    },
    triggerQrUpload() {
      if (this.qrUploading) return
      this.$refs.qrFileInput && this.$refs.qrFileInput.click()
    },
    async onQrFileChange(e) {
      const input = e.target
      const file = input.files && input.files[0]
      if (!file) return
      const allowed = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowed.includes(file.type)) {
        this.$message.error('只支持 JPG、JPEG、PNG 格式')
        input.value = ''
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 5MB')
        input.value = ''
        return
      }
      this.qrUploading = true
      try {
        const res = await uploadImage(file)
        if (res && res.code === 1) {
          const url = res.data && (res.data.url || res.data.fullurl || res.data)
          this.paymentQrCode = typeof url === 'string' ? url : (url && url.url) || ''
          if (this.qrPreview && this.qrPreview.startsWith('blob:')) {
            try { URL.revokeObjectURL(this.qrPreview) } catch (err) { /* ignore */ }
          }
          this.qrPreview = URL.createObjectURL(file)
          this.$message.success('收款码上传成功')
        } else {
          this.$message.error(res?.msg || '上传失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('上传失败，请重试')
      } finally {
        this.qrUploading = false
        input.value = ''
      }
    },
    updateWithdrawAmount() {
      // 限制提现金额不能超过余额
      if (parseFloat(this.withdrawAmount) > parseFloat(this.balanceAmount)) {
        this.withdrawAmount = this.balanceAmount
      }
    },
    withdrawAll() {
      this.withdrawAmount = this.balanceAmount
    },
    async handleWithdraw() {
      if (!this.withdrawAmount || this.withdrawAmount <= 0) {
        this.$message.warning('请输入提现金额')
        return
      }
      if (!this.selectedMethod) {
        this.$message.warning('请选择提现方式')
        return
      }
      if (this.selectedMethod === 'bank') {
        if (!this.bankName.trim() || !this.bankAccount.trim() || !this.bankBranch.trim()) {
          this.$message.warning('请填写完整的银行名称、银行卡号与开户行')
          return
        }
      } else if (this.selectedMethod === 'wechat' || this.selectedMethod === 'alipay') {
        if (!this.paymentQrCode) {
          this.$message.warning('请上传收款码')
          return
        }
      }
      if (parseFloat(this.withdrawAmount) < 10) {
        this.$message.warning('提现金额不能少于10元')
        return
      }
      if (parseFloat(this.withdrawAmount) > 50000) {
        this.$message.warning('提现金额不能超过50000元')
        return
      }

      // 检查是否有支付密码
      if (!this.userInfo.payment_password) {
        this.passwordDialogType = 'set'
        this.showPasswordDialog = true
        return
      }

      // 有支付密码，显示验证密码弹窗
      this.passwordDialogType = 'verify'
      this.showPasswordDialog = true
    },
    async performWithdraw(paymentPwd) {
      try {
        const pwd = paymentPwd !== undefined && paymentPwd !== null ? paymentPwd : this.paymentPassword
        const selectedMethodData = this.withdrawMethods.find(method => method.id === this.selectedMethod)
        if (!selectedMethodData) {
          this.$message.warning('请选择提现方式')
          return
        }
        const t = selectedMethodData.type
        const withdrawData = {
          withdraw_type: t,
          amount: this.withdrawAmount,
          payment_password: pwd
        }
        if (t === 1) {
          withdrawData.bank_name = this.bankName.trim()
          withdrawData.account = this.bankAccount.trim()
          withdrawData.bank_branch = this.bankBranch.trim()
        } else {
          withdrawData.payment_qr_code = this.paymentQrCode
        }

        const response = await withdraw(withdrawData)
        if (response && response.code === 1) {
          this.$message.success('提现申请已提交，请等待审核')
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000)
        } else {
          this.$message.error(response?.msg || '提现失败')
        }
      } catch (error) {
        console.error('提现失败:', error)
      }
    },
    async handlePasswordConfirm() {
      if (!this.paymentPassword) {
        this.$message.warning('请输入支付密码')
        return
      }
      if (this.paymentPassword.length < 6) {
        this.$message.warning('支付密码至少6位')
        return
      }

      if (this.passwordDialogType === 'set') {
        // 设置支付密码
        try {
          const pwd = this.paymentPassword
          const response = await setPaymentPassword({ password: pwd })
          if (response && response.code === 1) {
            this.$message.success('支付密码设置成功')
            this.showPasswordDialog = false
            this.paymentPassword = ''
            await this.fetchProfile()
            await this.performWithdraw(pwd)
          } else {
            this.$message.error(response?.msg || '设置支付密码失败')
          }
        } catch (error) {
          console.error('设置支付密码失败:', error)
          this.$message.error('设置支付密码失败，请重试')
        }
      } else {
        // 验证支付密码并提现
        await this.performWithdraw()
      }
    },
    cancelPasswordDialog() {
      this.showPasswordDialog = false
      this.paymentPassword = ''
    }
  }
}
</script>

<style scoped>
.tixian-container {
	width: var(--page-inner-ratio, 80%);
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
  margin: 0 auto;
}

/* 面包屑导航 */
.breadcrumb {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  cursor: pointer;
  color: #1E80FF;
}

.breadcrumb-item:hover {
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: #666;
  cursor: default;
}

.breadcrumb-item.active:hover {
  text-decoration: none;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}

.con-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 余额信息 */
.balance-info {
  text-align: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #1E80FF 0%, #0F71E3 100%);
  border-radius: 12px;
  color: #fff;
}

.balance-label {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.balance-amount {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

/* 提现金额 */
.withdraw-section {
  margin-bottom: 32px;
}

.withdraw-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.amount-input-container {
  position: relative;
  margin-bottom: 12px;
}

.currency-symbol {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #303133;
  font-weight: 600;
  z-index: 1;
}

.amount-input {
  width: 100%;
}

.amount-input .el-input__inner {
  padding-left: 40px;
  font-size: 18px;
  font-weight: 600;
  height: 50px;
  border: 2px solid #E4E7ED;
  border-radius: 8px;
}

.amount-input .el-input__inner:focus {
  border-color: #1E80FF;
}

.amount-tips {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.tip-text {
  color: #909399;
}

.all-btn {
  color: #1E80FF;
  cursor: pointer;
  font-weight: 600;
}

.all-btn:hover {
  text-decoration: underline;
}

/* 提现方式 */
.withdraw-methods {
  margin-bottom: 24px;
}

/* 提现账号 */
.withdraw-account {
  margin-bottom: 32px;
}

.account-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.account-input {
  width: 100%;
}

.account-input .el-input__inner {
  height: 50px;
  font-size: 16px;
  border: 2px solid #E4E7ED;
  border-radius: 8px;
}

.account-input .el-input__inner:focus {
  border-color: #1E80FF;
}

.bank-fields .field-row {
  margin-bottom: 16px;
}

.bank-fields .field-hint {
  display: block;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.qr-file-input {
  display: none;
}

.qr-upload-wrap {
  max-width: 280px;
}

.qr-upload-box {
  position: relative;
  min-height: 160px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #fafafa;
}

.qr-upload-box:hover {
  border-color: #1e80ff;
}

.qr-upload-box.uploading {
  cursor: not-allowed;
  opacity: 0.85;
}

.qr-preview-img {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 6px;
}

.qr-upload-icon {
  font-size: 36px;
  color: #c0c4cc;
  margin-bottom: 8px;
}

.qr-upload-text {
  font-size: 14px;
  color: #606266;
}

.qr-upload-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
}

.qr-upload-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
  font-size: 28px;
  color: #1e80ff;
}

.methods-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.methods-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.method-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 2px solid #E4E7ED;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
}

.method-item:hover {
  border-color: #1E80FF;
  background: #F0F9FF;
}

.method-item.active {
  border-color: #1E80FF;
  background: #E3F2FD;
}

.method-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.method-name {
  flex: 1;
  font-size: 16px;
  color: #303133;
  font-weight: 500;
}

.method-check {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* 提现信息 */
.withdraw-info {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 32px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item.total {
  padding-top: 12px;
  border-top: 1px solid #E4E7ED;
  font-weight: 600;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}

.info-item.total .info-value {
  color: #1E80FF;
  font-size: 18px;
}

/* 提现按钮 */
.withdraw-actions {
  margin-bottom: 32px;
}

.withdraw-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.withdraw-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

.withdraw-btn:disabled {
  background: #C0C4CC;
  border-color: #C0C4CC;
  color: #fff;
}

/* 提现说明 */
.withdraw-tips {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 20px;
}

.tips-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 600;
}

.tips-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tip-item {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

/* 支付密码弹窗样式 */
.password-dialog {
  padding: 20px 0;
}

.password-tip {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
}

.password-input {
  margin-bottom: 20px;
}

.password-input .el-input__inner {
  height: 50px;
  font-size: 18px;
  text-align: center;
  letter-spacing: 2px;
}

.password-tips {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 16px;
}

.password-tips .tip-item {
  margin-bottom: 8px;
  font-size: 13px;
  color: #666;
}

.password-tips .tip-item:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  text-align: center;
}

.dialog-footer .el-button {
  width: 100px;
  margin: 0 10px;
}
</style>
